import { request } from '@/shared/api/request'

export const getEmployerAffairs = ({ srcText = '', page = 1, size = 50 }) =>
	request({
		url: `contract/persCard/searchCard?srcText=${srcText}&page=${page}&size=${size}`,
		method: 'GET'
	})
